import { useState } from "react"
import { Box, Container, Typography, Grid, Button, Divider } from "@mui/material"
import SecurityIcon from "@mui/icons-material/Security"
import { useLocation } from "react-router-dom"
import PackageOption from "./PackageOption"
import T from "../hooks/Language/T"
import useTranslationSharie from "../hooks/Language/useTranslation"
import { useApiService } from "../hooks/Api/useApiService"
import UserDetails from "./UserDetails"
import axios from "axios"
import styles from "./Testamonies.module.css"
import Testamonies from "./Testamonies"
import TrustSidebar from "./TrustSidebar"

function BuyCredit() {
  const [selected_package, setSelectedPackage] = useState(null)
  const [user_details, setUserDetails] = useState({})
  const location = useLocation()
  const t = useTranslationSharie()

  const is_bussiness = location.state?.business
  const b2c_prices = [
    { amount: "100", price: "$5" },
    { amount: "250", price: "$10" },
    { amount: "1,000", price: "$25" },
    { amount: "5,000", price: "$50" },
    { amount: "30,000", price: "$100" },
    { amount: "210,000", price: "$200" },
  ]
  const b2b_prices = [{ amount: "unlimited", price: "$250 per user" }]
  const { BASE_URL } = useApiService()

  const onPackageSelect = (packageOption) => {
    setSelectedPackage(packageOption)
  }
  const handleBuyCredits = async () => {
    const packageByAmount = b2c_prices.find((item) => item.amount === selected_package)

    // try {
    //   const { data } = await axios.post(BASE_URL + "meshulam/pay", {
    //     amount: packageByAmount,
    //     description: "Payment for Sharie credits",
    //     full_name: user_details.full_name,
    //     email: user_details.email,
    //     phone: user_details.phone,
    //   })

    //   if (data?.data?.url) {
    //     window.location.href = data.data.url // Redirect to Meshulam payment page
    //   } else {
    //     alert("Error initiating payment")
    //   }
    // } catch (e) {
    //   alert("Payment failed: " + e.message)
    // }
  }

  return (
    <T>
      <div className={styles.row_container}>
        <div className={styles.column_trust_container}>
          <TrustSidebar />
        </div>
        <div className={styles.column_container}>
          <Container maxWidth='md' sx={{ mt: 8, mb: 8 }}>
            <Box textAlign='center' mb={6}>
              <Typography variant='h6' color='textSecondary'>
                Choose your package and securely complete your purchase with your credit card
              </Typography>
            </Box>

            {/* Credit Package Selection */}
            <Box mb={6}>
              {!is_bussiness && (
                <Typography variant='h5' fontWeight='bold' gutterBottom>
                  Select a Credit Package
                </Typography>
              )}
              <Grid container spacing={4}>
                {is_bussiness
                  ? b2b_prices.map((packageOption, index) => (
                      <PackageOption
                        key={index}
                        packageOption={packageOption}
                        selectedPackage={selected_package}
                        onPackageSelect={onPackageSelect}
                        index={index}
                      />
                    ))
                  : b2c_prices.map((packageOption, index) => (
                      <PackageOption
                        key={index}
                        packageOption={packageOption}
                        selectedPackage={selected_package}
                        onPackageSelect={onPackageSelect}
                        index={index}
                      />
                    ))}
              </Grid>
            </Box>

            <Divider sx={{ my: 6 }} />
            <UserDetails setUserDetails={setUserDetails} />

            {/* Security and CTA */}
            <Box display='flex' alignItems='center' justifyContent='center' flexDirection='column'>
              <SecurityIcon color='success' sx={{ fontSize: 40, mb: 1 }} />
              <Typography variant='body1' color='textSecondary' mb={2}>
                Secure payment with 256-bit encryption
              </Typography>
              <Button
                disabled={!selected_package}
                variant='contained'
                color='primary'
                size='large'
                onClick={handleBuyCredits}
              >
                Buy Credits
              </Button>
            </Box>
          </Container>
        </div>

        <div className={styles.column_container}>
          <Testamonies />
        </div>
      </div>
    </T>
  )
}

export default BuyCredit
